"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var rc_tabs_1 = __importDefault(require("rc-tabs"));
var react_2 = require("react");
var md_1 = require("react-icons/md");
var style_1 = require("../../style");
var styles_1 = require("./styles");
var More = function () { return (react_1.jsx("div", { css: react_1.css({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%',
        gap: 12,
    }) },
    react_1.jsx("span", null, "More"),
    react_1.jsx(md_1.MdKeyboardArrowDown, { size: 20 }))); };
var Tabs = function (_a) {
    var selected = _a.selected, _b = _a.type, type = _b === void 0 ? 'default' : _b, rcTabProps = __rest(_a, ["selected", "type"]);
    var theme = style_1.useTheme();
    var styles = react_2.useMemo(function () { return styles_1.getRcTabsStyles(theme, type); }, [theme, type]);
    return (react_1.jsx(react_2.Fragment, null,
        react_1.jsx(react_1.Global, { styles: styles }),
        react_1.jsx(rc_tabs_1.default, __assign({ moreIcon: react_1.jsx(More, null), destroyInactiveTabPane: true, prefixCls: styles_1.TAB_PREFIX_MAPPING[type] }, rcTabProps, { activeKey: selected }))));
};
exports.default = Tabs;
